import { useAuth } from '@/app/AuthContext.jsx';
import { useBankAccounts, useCan } from '@/hooks';
import { qk } from '@/lib/queryKeys';
import EditarCuentaBancariaModal from '@/pages/facturacion/EditarCuentaBancariaModal.jsx';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import PerfilView from './PerfilView.jsx';

export function displayName(user) {
  const name = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();
  return name || user?.email || 'Receptor';
}

export function mapBankAccounts(data) {
  const results = Array.isArray(data) ? data : (data?.results ?? []);
  return results.map((account) => ({
    bankAccountId: account.bankAccountId,
    bankCode: account.bankCode ?? '',
    accountType: account.accountType ?? '',
    holderName: account.holderName ?? '',
    accountNumber: account.accountNumber ?? '',
    rut: account.rut ?? '',
    isDefault: Boolean(account.isDefault),
  }));
}

export default function Perfil() {
  const { user, logout, organizationId } = useAuth();
  const canRead = useCan('bank:read');
  const canCreate = useCan('bank:create');
  const canUpdate = useCan('bank:update');
  const queryClient = useQueryClient();
  const { data, isError, isPending } = useBankAccounts(organizationId, {
    enabled: organizationId != null && canRead,
  });
  const accounts = useMemo(() => mapBankAccounts(data), [data]);
  const [editing, setEditing] = useState(null);

  async function handleSaved() {
    await queryClient.invalidateQueries({ queryKey: qk.bankAccounts.all() });
    setEditing(null);
  }

  return (
    <>
      <PerfilView
        name={displayName(user)}
        email={user?.email ?? ''}
        accounts={isError ? [] : accounts}
        failed={isError}
        readable={canRead}
        pending={canRead && organizationId != null && isPending}
        onAgregar={canCreate ? () => setEditing('new') : undefined}
        onEditar={canUpdate ? (account) => setEditing(account) : undefined}
        onLogout={() => logout()}
      />
      {editing ? (
        <EditarCuentaBancariaModal
          account={editing === 'new' ? undefined : editing}
          onClose={() => setEditing(null)}
          onSaved={handleSaved}
          flat
        />
      ) : null}
    </>
  );
}
